import { removeTrailingCharacters } from '../../string';

const removeTrailingZeros = (value: string): string => {
  const [integerPart, decimalPart] = value.split('.');

  if (!integerPart) return value;

  const decimalPartWithoutTrailingZeros = removeTrailingCharacters(
    decimalPart,
    '0',
  );

  return decimalPartWithoutTrailingZeros
    ? `${integerPart}.${decimalPartWithoutTrailingZeros}`
    : integerPart;
};

export default removeTrailingZeros;
